import { render, staticRenderFns } from "./MergeContactModal.vue?vue&type=template&id=00ddc7e5"
import script from "./MergeContactModal.vue?vue&type=script&lang=js"
export * from "./MergeContactModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports